import * as React from 'react';

import TextField from '@mui/material/TextField';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Stack from '@mui/material/Stack';
import Snackbar from './../../Components/Snackbar/Snackbar'
import PropTypes from "prop-types";
import { InputLabel, Paper, Tooltip } from '@mui/material';

import moment from 'moment/moment';
import 'moment/locale/th';



export default function CustomDateRangePicker(props) {
    //   const date = moment(moment().toDate()).format('DD/MM/YYYY')
    const { defaultValue } = props
    const [color, setColor] = React.useState("warning");
    const [icon, setIcon] = React.useState("");
    const [autoClose, setAutoClose] = React.useState(2000);
    const [message, setMessage] = React.useState("");
    const [opensnackbar, setOpensnackbar] = React.useState(false);
    const [datePickerdisabled, setdatePickerdisabled] = React.useState(false);

    const [state, setState] = React.useState({
        startDateValue: null,
        endDateValue: null,
        endDateEnable: true,
        checkAccept: false,
        loading: false
    });
    React.useEffect(async () => {
        console.log("state.startDateValue", state.startDateValue)
        if (state.startDateValue === null) {
            await setState({
                endDateEnable: false,
                ...state,
            })
        }
        return () => {
        }
    }, [state.startDateValue])

    React.useEffect(async () => {
        // moment(formatDate).format('DD/MM/YYYY')

        if ((defaultValue.dateStart !== "" && defaultValue.dateEnd !== "") &&
            (typeof defaultValue.dateStart !== "undefined" && typeof defaultValue.dateEnd !== "undefined")) {
            try {
                await setState({
                    ...state,
                    checkAccept: false,
                    startDateValue: defaultValue.dateStart !== "" ?
                        moment(defaultValue.dateStart) : "",
                    endDateValue: defaultValue.dateEnd !== "" ?
                        moment(defaultValue.dateEnd) : "",
                    loading: true,
                    endDateEnable: false
                })
            } catch (error) {
                console.log(error);
            }

        }
        return () => {
        }
    }, [defaultValue])

    React.useEffect(() => {
        // console.log("useEffect startdatevalue enddatevalue");
        if (state.checkAccept === true) {
            checkDate()
        }
        return () => {
        }
    }, [state.checkAccept])
    const checkDate = async () => {
        console.log("checkDate startdatevalue", state.startDateValue, " checkDate enddatevalue", state.endDateValue)
        if (state.startDateValue !== null && moment(state.startDateValue).isAfter() === true) {
            setOpensnackbar(true)
            setMessage("วันที่เริ่มต้นไม่ถูกต้อง")
            await setState({
                ...state,
                startDateValue: null,
                endDateEnable: true,
                checkAccept: false,
            })
            return
        }
        if (state.startDateValue !== null && state.endDateValue !== null) {
            let result = moment(state.endDateValue).diff(moment(state.startDateValue), 'hours');
            // console.log("dateDiffResult", result);
            if (result > -1) {
                props.resData({
                    dateStart: state.startDateValue,
                    dateEnd: state.endDateValue
                })
            }
            else {
                setOpensnackbar(true)
                setMessage("เลือกวันที่ไม่ถูกต้องกรุณาเลือกวันที่เริ่มต้นให้ใหม่")

                await setState({
                    ...state,
                    endDateValue: null,
                    checkAccept: false,
                })
                return
            }
        }
        // else {
        //     props.resData({ dateStart: state.startDateValue, dateEnd: state.endDateValue })
        // }

        await setState({
            ...state,
            checkAccept: false,
        })
    }
    const styles = {
        textField: {
            fontFamily: "Customfont !important"
        }
    }
    return (

        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={"th"} >
            <Stack spacing={0} direction={{ base: 'row' }} >
                <Paper
                    elevation={0}
                    component="div"
                    sx={{
                        pl: '3px',
                        pt: '0px',
                        m: "0px",
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: "#eee",
                        border: "1px solid #ccc",
                        verticalAlign: "middle",
                        alignContent: 'center'
                    }}
                >
                    <Tooltip title={props.label}>
                        <InputLabel sx={{

                            display: 'inline-table',
                            whiteSpace: 'nowrap',
                            fontSize: "16px",
                            fontFamily: "Customfont !important",
                            color: "black",
                            verticalAlign: "middle",
                            paddingLeft: "5px",
                            paddingRight: "5px"
                        }}  >{props.label}</InputLabel>
                    </Tooltip>
                    <DatePicker
                        disabled={datePickerdisabled}
                        value={state.startDateValue}
                        renderInput={(params) =>
                            <TextField {...params} sx={{
                                backgroundColor: "#fff",
                                fontFamily: "Customfont"
                            }}
                                fullWidth={true}
                                hiddenLabel
                                variant="standard"
                                size="small"
                            />
                        }
                        onChange={async (newValue) => {
                            console.log("start DateValue", newValue)
                            await setState({
                                ...state,
                                startDateValue: newValue,
                                checkAccept: true,
                                endDateEnable: false,

                            })
                        }}
                        onClose={(_) => { console.log("onClose "); }}
                    /> <Tooltip title={props.label2}>
                        <InputLabel sx={{
                            display: 'inline-table',
                            whiteSpace: 'nowrap',
                            fontSize: "16px",
                            fontFamily: "Customfont !important",
                            color: "black",
                            verticalAlign: "middle",
                            paddingLeft: "5px",
                            paddingRight: "5px"
                        }}  >{props.label2}</InputLabel>
                    </Tooltip>
                    <DatePicker
                        disabled={state.endDateEnable}
                        value={state.endDateValue}
                        renderInput={(params) =>
                            <TextField {...params} sx={{
                                backgroundColor: "#fff",
                                fontFamily: "Customfont"

                            }}
                                fullWidth={true}
                                hiddenLabel
                                variant="standard"
                                size="small"

                            />}

                        onChange={async (newValue) => {
                            console.log("end DateValue", newValue)
                            await setState({
                                ...state,
                                endDateValue: newValue,
                                checkAccept: true
                            })
                        }}
                        onClose={(_) => {
                            //console.log("onClose");
                        }}

                    />
                </Paper>
            </Stack>

            <Snackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={message}
                open={opensnackbar}
                closeNotification={() => { setOpensnackbar(false) }}
                close />
        </LocalizationProvider >
    );
}

CustomDateRangePicker.propTypes = {
    defaultValue: PropTypes.object.isRequired,
    label: PropTypes.string,
    label2: PropTypes.string,
}
CustomDateRangePicker.defaultProps = {
    label: "วันที่เริ่มต้น",
    label2: "วันที่สิ้นสุด"
}